import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('email_template')
export class EmailTemplateEntity<
	TVariablesInterface extends Record<string, unknown> = Record<string, unknown>,
> extends BaseEntity {
	@Column({ type: 'varchar', length: 255, unique: true })
	public name!: string;

	@Column({ type: 'text', nullable: true })
	public description?: string;

	@Column({ type: 'longtext' })
	public template!: string;

	@Column({ type: 'json', nullable: true })
	public variables?: Array<{
		name: keyof TVariablesInterface;
		type: string;
		required: boolean;
		defaultValue?: unknown;
		description?: string;
	}>;

	@Column({ name: 'is_active', type: 'boolean', default: true })
	@Index()
	public isActive!: boolean;

	@Column({ type: 'json', nullable: true })
	public metadata?: Record<string, unknown>;

	@Column({ type: 'varchar', length: 100, unique: true, nullable: true })
	public systemSlug?: string;
}
